<script setup lang="ts">
import { computed } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import ActionMenuButton from "@/components/menu/ActionMenu/ActionMenuButton.vue";
import { isActionVisible } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => isActionVisible("activity", card, board.value));
</script>

<template>
  <ActionMenuButton v-if="isVisible" :action="toggleActions.toggleCardHistory" />
</template>
